const BASE_URL: string = 'https://www.nepalstock.com.np';

export { BASE_URL };
